import { DesignerMeta_User } from '__generated__/DesignerMeta_User';
import { DesignerSource } from '__generated__/types';
import DesignerMetaHeader from 'projects/components/DesignerMetaHeader';
import React, { useContext } from 'react';
import AddDesignerButton from './AddDesignerButton';
import BriefContext from './BriefContext';

interface Props {
    brief: {
        id: string;
        designers: DesignerMeta_User[];
        contacts: DesignerMeta_User[];
    };
}

const Contacts = ({ brief }: Props) => {
    const { totalAllowableDesigners } = useContext(BriefContext);

    return (
        <>
            <div className="contacts-drawer__item-list">
                {brief.contacts.map(designer => (
                    <div className="contacts-drawer__item" key={designer.id}>
                        <div className="contacts-drawer__meta-wrapper">
                            <DesignerMetaHeader
                                designer={designer}
                                paragraphSize={'small'}
                                avatarSize={'small'}
                            />
                            <div className="contacts-drawer__meta-wrapper__cta">
                                <AddDesignerButton
                                    designer={designer}
                                    designerSource={DesignerSource.CONTACT}
                                    brief={brief}
                                    totalAllowableDesigners={totalAllowableDesigners}
                                />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
};

export default Contacts;
